import React from 'react';

import { faFileInvoiceDollar } from '@fortawesome/pro-regular-svg-icons';
import { Link } from 'react-router-dom';

import AutocompleteSearch from '../components/AutocompleteSearch';
import StrongTextField from '../components/StrongTextField';

export default {
  name: 'factures',
  icon: faFileInvoiceDollar,
  title: 'Factures',
  resource: 'factures',
  primaryKey: 'idfacture',
  associations: ['*vente'],
  query: {
    'vente._associations': 'commercial,lot',
    'vente.lot._associations': 'prog',
    'vente.lot.prog._associations': 'promoteur',
  },
  head: {
    date_numerotation: 'Date numérotation',
    num_facture: 'Numéro',
    facture_type: 'Type',
    stade_facture: 'Stade',
    date_reglement_prevue: 'Date règlement prévu',
    date_reglement_effectue: 'Date règlement effectué',
    idvente: 'Vente',
    lot: 'Lot',
    programme: 'Programme',
    promoteur: 'Promoteur',
    commercial: 'Commercial',
  },
  list: ({ values }) => [
    values.date_numerotation,
    values.prefixe_num_facture + values.num_facture,
    values.facture_type,
    values.stade_facture,
    values.date_reglement_prevue,
    values.date_reglement_effectue,
    <Link to={{ pathname: `/i9/ventes/${values.idvente}` }}>#{values.idvente}</Link>,
    <Link to={{ pathname: `/i9/lots/${values.vente?.idlot}` }}>{values.vente?.lot?.ref}</Link>,
    <Link to={{ pathname: `/i9/programmes/${values.vente?.lot?.idprog}` }}>{values.vente?.lot?.prog?.nom}</Link>,
    <Link to={{ pathname: `/i9/promoteurs/${values.vente?.lot?.prog?.idpromoteur}` }}>
      {values.vente?.lot?.prog?.promoteur?.nom}
    </Link>,
    <Link to={{ pathname: `/i9/individus/${values.vente?.idindividu}` }}>
      {values.vente?.commercial?.nom} {values.vente?.commercial?.prenom}
    </Link>,
  ],
  filter: ({ values, props, setFieldValue, handleSubmit }) => [
    <StrongTextField name='num_facture' label='Numéro' values={values.nom} {...props} />,
    <AutocompleteSearch
      {...props}
      resource='entite_cliente'
      optionLabel={option => option.nom}
      attribute='nom'
      label='Nom client'
      onChange={(event, value) => {
        setFieldValue("['vente.identiteclient']", value?.identite);
        handleSubmit();
      }}
    />,
  ],
  show: true,
  remove: true,
  options: {
    date_numerotation: '$not:null',
  },
  sort: '-date_numerotation',
};
